/**
 * @description 获取当前网址
 * @returns {string}
 */
export const addressBarCurrent = (): string => location.href
